import {Dispatchable} from "../../../stem-core/base/Dispatcher";
import {StemDate} from "../../../stem-core/time/Date";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {FieldDescriptor} from "../../../stem-core/state/StoreField";

// Simulate a store for this
export class FileResource extends Dispatchable {
    static cache = new Map<string, FileResource>();
    fileResourceId: string;
    response?: FileResourceResponse;

    constructor(fileResourceId: string) {
        super();
        if (!fileResourceId) {
            throw "Missing file resource Id";
        }
        this.fileResourceId = fileResourceId;
    }

    async getURL(): Promise<string> {
        if (this.response) {
            // TODO handle if the url is expired
            return this.response.url;
        }
        this.response = await apiGetFileResourceURL(this.fileResourceId);
        this.response.expiresAt = new StemDate(this.response.expiresAt);
        return this.response.url;
    }

    static optionally(fileResourceId: string | null): FileResource | null {
        if (fileResourceId == null) {
            return null;
        }
        if (!this.cache.has(fileResourceId)) {
            this.cache.set(fileResourceId, new this(fileResourceId));
        }
        return this.cache.get(fileResourceId)!;
    }

    static makeFieldLoader(fieldDescriptor: FieldDescriptor): (value: string | null) => FileResource | null {
        fieldDescriptor.rawField = fieldDescriptor.rawField || (key => key + "Id");

        return (value) => this.optionally(value);
    }
}

interface FileResourceResponse {
    url: string;
    expiresAt: StemDate;
    fileSize: number;
}


export async function apiGetFileResourceURL(fileResourceId: string): Promise<FileResourceResponse> {
    return apiClient.get<FileResourceResponse>("/merchant/get_file_resource_url", {fileId: fileResourceId});
}
